import { CheckboxFilterElement } from "./checkboxFilter.element";

export class AbFilterBrandElement extends CheckboxFilterElement<string> {
  constructor() {
    super({ label: "Produttore", eventName: "brand-filter-change", optionLabel: (value) => value });
  }
}

export const defineAbFilterBrandElement = () => {
  if (!customElements.get("ab-filter-brand")) customElements.define("ab-filter-brand", AbFilterBrandElement);
};
